@if (_delivery.addressDefined) {
  <p
    class="selected-address"
    [ngClass]="isDecisionPoint ? 'decision-point' : ''"
  >
    <span> {{ label }}</span
    ><br />
    {{ address }}
  </p>
}
